<template>
  <div class="page-wrapper">
    <div class="module" style="width: 960px;">
      <div class="table-head">
        <h3>证书类型</h3>
        <el-button type="primary" size="small" @click="addCerTypeDialogVisible = true">新增证书类型</el-button>
      </div>
      <el-table v-loading="loading1" :data="certificateTypesData" border>
        <el-table-column label="证书类型" prop="categoryName"></el-table-column>
        <el-table-column label="会员级别">
          <template slot-scope="scope">
            <div class="cell-box">
              <div class="cell-item" v-for="(item, index) in scope.row.children" :key="index">
                {{item.categoryName}}
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="证书类型名称显示文字">
          <template slot-scope="scope">
            <div class="cell-box">
              <div class="cell-item" v-for="(item, index) in scope.row.children" :key="index">
                {{item.displayName}}
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="会员级别显示文字">
          <template slot-scope="scope">
            <div class="cell-box">
              <div class="cell-item" v-for="(item, index) in scope.row.children" :key="index">
                {{item.displayText}}
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="证书模板">
          <template slot-scope="scope">
            <div class="cell-box">
              <div class="cell-item" v-for="(item, index) in scope.row.children" :key="index">
                <img class="cer-tem-pic" v-if="item.certificateImage" :src="item.showUrl" alt="证书模板">
                <span v-else>无</span>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button type="primary" plain size="mini" @click="editGradeHandle(scope.row)">编辑等级</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div class="module" style="width: 300px; margin-top: 32px;">
      <div class="table-head">
        <h3>类目/业务等级</h3>
        <el-button type="primary" size="small" @click="addBusinessGradeDialogVisible = true">新增类目/业务等级</el-button>
      </div>
      <el-table v-loading="loading4" :data="businessGradeData" border>
        <el-table-column label="类目/业务等级" prop="categoryName"></el-table-column>
      </el-table>
    </div>

    <div class="module" style="width: 300px; margin-top: 32px;">
      <div class="table-head">
        <h3>类目/业务类型</h3>
        <el-button type="primary" size="small" @click="addBusinessTypeDialogVisible = true">新增类目/业务类型</el-button>
      </div>
      <el-table v-loading="loading4" :data="businessTypeData" border>
        <el-table-column label="类目/业务类型" prop="categoryName"></el-table-column>
      </el-table>
    </div>
    
    <div class="module" style="width: 300px; margin-top: 32px;">
      <div class="table-head">
        <h3>会员来源</h3>
        <el-button type="primary" size="small" @click="addResourceDialogVisible = true">新增来源</el-button>
      </div>
      <el-table v-loading="loading2" :data="resourceData" border>
        <el-table-column label="会员来源" prop="categoryName"></el-table-column>
      </el-table>
    </div>

    <div class="module" style="width: 300px; margin-top: 32px;">
      <div class="table-head">
        <h3>主体类型</h3>
        <el-button type="primary" size="small" @click="addSubjectTypeDialogVisible = true">新增主体类型</el-button>
      </div>
      <el-table v-loading="loading3" :data="subjectTypeData" border>
        <el-table-column label="主体类型" prop="categoryName"></el-table-column>
      </el-table>
    </div>

    <!-- 新增证书类型 -->
    <el-dialog 
      title="新增证书类型" 
      :visible.sync="addCerTypeDialogVisible" 
      width="900px" 
      :close-on-click-modal="false"
      center
    >
      <el-form :model="addCerTypeForm" ref="addCerTypeForm" label-width="180px" >
        <el-form-item 
          label="证书类型名称：" 
          prop="categoryName"
          :rules="[
            { required: true, message: '请输入证书类型名称', trigger: 'blur' }
          ]"
        >
          <el-input 
            style="width: 400px" 
            v-model="addCerTypeForm.categoryName"
            placeholder="请输入证书类型名称"
          ></el-input>
        </el-form-item>

        <el-form-item 
          label="证书类型名称显示文字：" 
          prop="topDisplayName"
          :rules="[
            { required: true, message: '请输入证书类型名称显示文字', trigger: 'blur' }
          ]"
        >
          <el-input 
            style="width: 400px" 
            v-model="addCerTypeForm.topDisplayName"
            placeholder="请输入证书类型名称显示文字"
          ></el-input>
        </el-form-item>
        <el-divider></el-divider>
        <el-row style="border-bottom: 1px dashed #DCDFE6;margin-bottom: 24px" :gutter="20" v-for="(item, index) in addCerTypeForm.memberLevelDTOList" :key="item.key">
          <el-col :span="12">
            <el-form-item 
              label="会员级别：" 
              :prop="'memberLevelDTOList.' + index + '.categoryName'"
              :rules="[
                { required: true, message: '请输入会员级别', trigger: 'blur' }
              ]"
            >
              <el-input
                v-model="item.categoryName"
                placeholder="请输入会员级别"
              ></el-input>
            </el-form-item>
            <!-- <el-form-item 
              label="证书类型名称显示文字：" 
              :prop="'memberLevelDTOList.' + index + '.displayName'"
              :rules="[
                { required: true, message: '请输入证书类型名称显示文字', trigger: 'blur' }
              ]"
            >
              <el-input
                v-model="item.displayName"
                placeholder="请输入证书类型名称显示文字"
              ></el-input>
            </el-form-item> -->
            <el-form-item 
              label="会员级别显示文字：" 
              :prop="'memberLevelDTOList.' + index + '.displayText'"
              :rules="[
                { required: true, message: '请输入会员级别显示文字', trigger: 'blur' }
              ]"
            >
              <el-input
                v-model="item.displayText"
                placeholder="请输入会员级别显示文字"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="9">
            <el-form-item label="证书模板：" >
              <el-upload
                class="cg-img-uploader"
                name="files"
                :action="uploadFileApi"
                :data="uploadData"
                :show-file-list="false"
                :on-success="(res, file) => handleImgSuccess(res, file, 'addCerTypeForm.memberLevelDTOList', index)"
                :before-upload="beforeImgUpload"
                :on-error="handleImgError"
                accept="image/*"
              >
                <img 
                  v-if="item.showUrl" 
                  :src="item.showUrl" 
                  class="cg-img small"
                  style="object-fit: contain"
                >
                <i v-else class="el-icon-plus cg-img-uploader-icon small"></i>
              </el-upload>
            </el-form-item>
          </el-col>
          <el-col :span="3">
            <i class="el-icon-remove c-remove" 
              :class="{'disabled': addCerTypeForm.memberLevelDTOList.length === 1}" 
              :title="addCerTypeForm.memberLevelDTOList.length > 1 ? '删除该行': '只有一行，不允许删除'"
              @click="removeLine('addCerTypeForm.memberLevelDTOList', index)"
            ></i>
            <i class="el-icon-circle-plus c-add" title="添加一行"
              @click="addLine('addCerTypeForm.memberLevelDTOList', index)"
            ></i>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="addCerTypeHandle">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 编辑证书类型 -->
    <el-dialog 
      title="编辑证书类型" 
      :visible.sync="editCerTypeDialogVisible" 
      width="900px" 
      :close-on-click-modal="false"
      center
    >
      <el-form :model="editCerTypeForm" ref="editCerTypeForm" label-width="180px" >
        <el-form-item 
          label="证书类型名称：" 
        >
          <span>{{editCerTypeForm.categoryName}}</span>
        </el-form-item>
        <el-form-item 
          label="证书类型名称显示文字：" 
          prop="topDisplayName"
          :rules="[
            { required: true, message: '请输入证书类型名称显示文字', trigger: 'blur' }
          ]"
        >
          <el-input 
            style="width: 400px" 
            v-model="editCerTypeForm.topDisplayName"
            placeholder="请输入证书类型名称显示文字"
          ></el-input>
        </el-form-item>
        <el-divider></el-divider>
        <el-row style="border-bottom: 1px dashed #DCDFE6;margin-bottom: 24px" :gutter="20" v-for="(item, index) in editCerTypeForm.memberLevelDTOList" :key="item.key">
          <el-col :span="12">
            <el-form-item 
              label="会员级别：" 
              :prop="'memberLevelDTOList.' + index + '.categoryName'"
              :rules="[
                { required: true, message: '请输入会员级别', trigger: 'blur' }
              ]"
            >
              <span v-if="!!item.categoryId">{{item.categoryName}}</span>
              <el-input
                v-else
                v-model="item.categoryName"
                placeholder="请输入会员级别"
              ></el-input>
            </el-form-item>
            <!-- <el-form-item 
              label="证书类型名称显示文字：" 
              :prop="'memberLevelDTOList.' + index + '.displayName'"
              :rules="[
                { required: true, message: '请输入证书类型名称显示文字', trigger: 'blur' }
              ]"
            >
              <el-input
                v-model="item.displayName"
                placeholder="请输入证书类型名称显示文字"
              ></el-input>
            </el-form-item> -->
            <el-form-item 
              label="会员级别显示文字：" 
              :prop="'memberLevelDTOList.' + index + '.displayText'"
              :rules="[
                { required: true, message: '请输入会员级别显示文字', trigger: 'blur' }
              ]"
            >
              <el-input
                v-model="item.displayText"
                placeholder="请输入会员级别显示文字"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="9">
            <el-form-item label="证书模板：" >
              <el-upload
                class="cg-img-uploader"
                name="files"
                :action="uploadFileApi"
                :data="uploadData"
                :show-file-list="false"
                :on-success="(res, file) => handleImgSuccess(res, file, 'editCerTypeForm.memberLevelDTOList', index)"
                :before-upload="beforeImgUpload"
                :on-error="handleImgError"
                accept="image/*"
              >
                <img 
                  v-if="item.showUrl" 
                  :src="item.showUrl" 
                  class="cg-img small"
                  style="object-fit: contain"
                >
                <i v-else class="el-icon-plus cg-img-uploader-icon small"></i>
              </el-upload>
            </el-form-item>
          </el-col>
          <el-col :span="3">
            <i class="el-icon-remove c-remove" 
              v-if="!item.categoryId"
              title="删除该行"
              @click="removeLine('editCerTypeForm.memberLevelDTOList', index)"
            ></i>
            <i class="el-icon-circle-plus c-add" title="添加一行"
              @click="addLine('editCerTypeForm.memberLevelDTOList', index)"
            ></i>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="editCerTypeHandle">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 新增来源 -->
    <el-dialog 
      title="新增来源" 
      :visible.sync="addResourceDialogVisible" 
      width="800px" 
      :close-on-click-modal="false"
      center
    >
      <el-form :model="addResourceForm" ref="addResourceForm" label-width="140px" >
        <el-form-item 
          label="来源名称：" 
          prop="categoryName"
          :rules="[
            { required: true, message: '请输入来源名称', trigger: 'blur' }
          ]"
        >
          <el-input 
            style="width: 400px" 
            v-model="addResourceForm.categoryName"
            placeholder="请输入来源名称"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="addResourceHandle">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 新增主体类型 -->
    <el-dialog 
      title="新增主体类型" 
      :visible.sync="addSubjectTypeDialogVisible" 
      width="800px" 
      :close-on-click-modal="false"
      center
    >
      <el-form :model="addSubjectTypeForm" ref="addSubjectTypeForm" label-width="140px" >
        <el-form-item 
          label="主体类型：" 
          prop="categoryName"
          :rules="[
            { required: true, message: '请输入主体类型', trigger: 'blur' }
          ]"
        >
          <el-input 
            style="width: 400px" 
            v-model="addSubjectTypeForm.categoryName"
            placeholder="请输入主体类型"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="addSubjectTypeHandle">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 新增类目/业务等级 -->
    <el-dialog 
      title="新增类目/业务等级" 
      :visible.sync="addBusinessGradeDialogVisible" 
      width="800px" 
      :close-on-click-modal="false"
      center
    >
      <el-form :model="addBusinessGradeForm" ref="addBusinessGradeForm" label-width="140px" >
        <el-form-item 
          label="类目/业务等级：" 
          prop="categoryName"
          :rules="[
            { required: true, message: '请输入类目/业务等级', trigger: 'blur' }
          ]"
        >
          <el-input 
            style="width: 400px" 
            v-model="addBusinessGradeForm.categoryName"
            placeholder="请输入类目/业务等级"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="addBusinessGradeHandle">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 新增类目/业务类型 -->
    <el-dialog 
      title="新增类目/业务类型" 
      :visible.sync="addBusinessTypeDialogVisible" 
      width="800px" 
      :close-on-click-modal="false"
      center
    >
      <el-form :model="addBusinessTypeForm" ref="addBusinessTypeForm" label-width="140px" >
        <el-form-item 
          label="类目/业务类型：" 
          prop="categoryName"
          :rules="[
            { required: true, message: '请输入类目/业务类型', trigger: 'blur' }
          ]"
        >
          <el-input 
            style="width: 400px" 
            v-model="addBusinessTypeForm.categoryName"
            placeholder="请输入类目/业务等级"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="addBusinessTypeHandle">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { utils } from "@/common/common.js";
import { request, api } from '@/common/request_course.js';
import { Loading } from 'element-ui';
import { buildThumborUrl } from '@/common/tool.js'
export default {
  name: "certificate-config",
  data() {
    return {
      loading1: false,
      certificateTypesData: [],

      loading2: false,
      resourceData: [],

      loading3: false,
      subjectTypeData: [],

      loading4: false,
      businessGradeData: [],

      loading5: false,
      businessTypeData: [],

      // 上传图片api
      uploadFileApi: api.baseUrl + '/minio-oss/fileUpload',
      uploadData: {
        bucketName: 'fzzht-certificate-image',
      },

      // 新增证书类型
      addCerTypeForm: {
        categoryName: '',
        topDisplayName: '',
        memberLevelDTOList: [
          {
            key: '1',
            categoryName: '',
            displayName: '',
            displayText: '',
            certificatePath: '',
            showUrl: ''
          }
        ]
      },
      addCerTypeDialogVisible: false,

      // 编辑证书类型
      editCerTypeRow: null,
      editCerTypeForm: {
        categoryName: '',
        topDisplayName: '',
        memberLevelDTOList: []
      },
      editCerTypeDialogVisible: false,

      // 新增来源
      addResourceForm: {
        categoryName: '',
      },
      addResourceDialogVisible: false,

      // 新增主体类型
      addSubjectTypeForm: {
        categoryName: '',
      },
      addSubjectTypeDialogVisible: false,

      // 新增类目/业务等级
      addBusinessGradeForm: {
        categoryName: '',
      },
      addBusinessGradeDialogVisible: false,

      // 新增类目/业务类型
      addBusinessTypeForm: {
        categoryName: '',
      },
      addBusinessTypeDialogVisible: false,
    }
  },
  created() {
    this.getCerTypeList()
    this.getResourceList()
    this.getSubjectTypeList()
    this.getBusinessGradeList()
    this.getBusinessTypeList()
  },
  computed: {
    IMG_PREV() {
      return api.imgPrev;
    },
    adminId() {
      return utils.getAdminId();
    },
    token() {
      return utils.getToken();
    },
  },
  watch: {},
  components: {},
  methods: {
    beforeImgUpload(file) {
      console.log(file)
      const isRequiredImg = /^image\/[jpg|jpeg|png]/.test(file.type)
      const isLimit = file.size / 1024 / 1024 < 10
      if (!isRequiredImg) {
        this.$message.error('请上传.jpg或.png格式的图片!');
      }
      if (!isLimit) {
        this.$message.error('上传图片大小不能超过 10MB!');
      }
      return isRequiredImg && isLimit;
    },
    handleImgSuccess(res, file, key, index) {
      console.log(res, file, key, index)
      if (res.erroyCode == 200) {
        let keys = key.split('.');
        this[keys[0]][keys[1]][index].certificatePath = res.data[0]
        this[keys[0]][keys[1]][index].showUrl = URL.createObjectURL(file.raw)

        console.log(this[keys[0]][keys[1]])
      } else {
        this.$message.error(res.errorMsg || '上传失败')
      }
    },
    handleImgError(err){
      console.log(err);
      this.$message.error('上传失败')
    },

    removeLine(key, index) {
      if (key.indexOf('.')>=0) {
        let keys = key.split('.');
        if (keys.length == 2) {
          let length = this[keys[0]][keys[1]].length
          if (length <= 1) return
          this[keys[0]][keys[1]].splice(index, 1)
        } else {
          console.warn('Please improve this feature.')
        }
      } else {
        let length = this[key].length
        if (length <= 1) return
        this[key].splice(index, 1)
      }
    },
    // 添加一行
    addLine(key, index) {
      let d = Date.now()
      let item = {
        key: d,
        categoryName: '',
        displayName: '',
        displayText: '',
        certificatePath: '',
        showUrl: ''
      }
      if (key.indexOf('.')>=0) {
        let keys = key.split('.');
        if(keys.length == 2) {
          this[keys[0]][keys[1]].splice(index+1, 0, item)
        } else {
          console.warn('Please improve this feature.')
        }
      } else {
        this[key].splice(index+1, 0, item)
      }
    },
    // 获取证书类型列表
    getCerTypeList() {
      this.loading1 = true
      request({
        url: api.baseUrl + "/certificate/yijiajia-data-category/listTree",
        method: "get",
        params: {
          categoryType: '20203'
        }
      }).then(res => {
        console.log(res);
        if (res.erroyCode == 200) {
          this.certificateTypesData = res.data.map(item => {
            return ({
              ...item,
              children: item.children.map(ele => ({
                ...ele,
                showUrl: buildThumborUrl(ele.certificateImage, {width: 200})
              }))
            })
          })
        } else {
          this.$message.error(res.errorMsg || "网络错误");
        }
      }).catch((err) => {
        console.log(err);
      })
      .finally(() => {
        this.loading1 = false
      })
    },
    // 获取来源列表
    getResourceList() {
      this.loading2 = true
      request({
        url: api.baseUrl + "/certificate/yijiajia-data-category/listTree",
        method: "get",
        params: {
          categoryType: '20202'
        }
      }).then(res => {
        console.log(res);
        if (res.erroyCode == 200) {
          this.resourceData = res.data
        } else {
          this.$message.error(res.errorMsg || "网络错误");
        }
      }).catch((err) => {
        console.log(err);
      })
      .finally(() => {
        this.loading2 = false
      })
    },
    // 获取主体类型列表
    getSubjectTypeList() {
      this.loading3 = true
      request({
        url: api.baseUrl + "/certificate/yijiajia-data-category/listTree",
        method: "get",
        params: {
          categoryType: '20201'
        }
      }).then(res => {
        console.log(res);
        if (res.erroyCode == 200) {
          this.subjectTypeData = res.data
        } else {
          this.$message.error(res.errorMsg || "网络错误");
        }
      }).catch((err) => {
        console.log(err);
      })
      .finally(() => {
        this.loading3 = false
      })
    },

    // 获取类目/业务等级
    getBusinessGradeList() {
      this.loading4 = true
      request({
        url: api.baseUrl + "/certificate/yijiajia-data-category/listTree",
        method: "get",
        params: {
          categoryType: '20204'
        }
      }).then(res => {
        console.log(res);
        if (res.erroyCode == 200) {
          this.businessGradeData = [
            {
              categoryId: '000000',
              categoryName: "无",
              categoryStatus: "y",
              categoryType: 20204,
              children: [],
              parentId: 0
            }].concat(res.data)
        } else {
          this.$message.error(res.errorMsg || "网络错误");
        }
      }).catch((err) => {
        console.log(err);
      })
      .finally(() => {
        this.loading4 = false
      })
    },

    // 获取类目/业务类型
    getBusinessTypeList() {
      this.loading5 = true
      request({
        url: api.baseUrl + "/certificate/yijiajia-data-category/listTree",
        method: "get",
        params: {
          categoryType: '20205'
        }
      }).then(res => {
        console.log(res);
        if (res.erroyCode == 200) {
          this.businessTypeData = [
            {
              categoryId: '000000',
              categoryName: "无",
              categoryStatus: "y",
              categoryType: 20205,
              children: [],
              parentId: 0
            }].concat(res.data)
        } else {
          this.$message.error(res.errorMsg || "网络错误");
        }
      }).catch((err) => {
        console.log(err);
      })
      .finally(() => {
        this.loading5 = false
      })
    },

    // 新增证书类型
    addCerTypeHandle() {
      let memberLevelDTOList = this.addCerTypeForm.memberLevelDTOList.map(item => {
        return ({
          categoryName: item.categoryName,
          displayName: this.addCerTypeForm.topDisplayName,
          displayText: item.displayText,
          certificatePath: item.certificatePath
        })
      })
      let params = {
        categoryCreateAdminId: this.adminId,
        categoryName: this.addCerTypeForm.categoryName,
	      categoryType: '20203',
        parentId: 0,
        memberLevelDTOList,
      }
      this.$refs['addCerTypeForm'].validate((valid) => {
        if (valid) {
          let loadingInstance = Loading.service({
            text: '正在提交...'
          });
          request({
            url: api.baseUrl + "/certificate/yijiajia-data-category/save",
            method: "post",
            data: params
          })
          .then((res) => {
            // console.log(res);
            if (res.erroyCode == 200) {
              this.addCerTypeDialogVisible = false
              this.getCerTypeList()
              this.$refs['addCerTypeForm'].resetFields();
              this.addCerTypeForm = {
                categoryName: '',
                topDisplayName: '',
                memberLevelDTOList: [
                  {
                    key: '1',
                    categoryName: '',
                    displayName: '',
                    displayText: '',
                    certificatePath: '',
                    showUrl: ''
                  }
                ]
              }
            } else {
              this.$message.error(res.errorMsg || "网络错误");
            }
          })
          .catch((err) => {
            console.log(err);
          })
          .finally(() => {
            loadingInstance.close();
          });

        } 
      })
    },
    // 编辑等级
    editGradeHandle(row) {
      console.log(row)
      this.editCerTypeRow = row
      this.editCerTypeForm.categoryName = row.categoryName
      this.editCerTypeForm.memberLevelDTOList = row.children.map((item,index) => {
        if (index === 0) {this.editCerTypeForm.topDisplayName = item.displayName}
        return ({
          key: item.categoryId,
          categoryId: item.categoryId,
          categoryName: item.categoryName,
          displayName: item.displayName,
          displayText: item.displayText,
          certificatePath: item.certificateImage,
          showUrl: buildThumborUrl(item.certificateImage, {with: 200})
        })
      })
      this.editCerTypeDialogVisible = true
    },
    // 确认编辑
    editCerTypeHandle() {
      console.log(this.editCerTypeForm)
      this.$refs['editCerTypeForm'].validate((valid) => {
        if (valid) {
          let loadingInstance = Loading.service({
            text: '正在提交...'
          });
          let addParams, editParms
          editParms = this.editCerTypeForm.memberLevelDTOList
            .filter(item => !!item.categoryId)
            .map(item => ({
              categoryType: this.editCerTypeRow.categoryType,
              certificateImage: item.certificatePath,
              lastUpdateBy: this.adminId,
              levelId: item.categoryId,
              levelName: item.categoryName,
              displayName: this.editCerTypeForm.topDisplayName,
              displayText: item.displayText,
              parentId: this.editCerTypeRow.categoryId,
            }))
          addParams = this.editCerTypeForm.memberLevelDTOList
            .filter(item => !item.categoryId)
            .map(item => ({
              categoryType: this.editCerTypeRow.categoryType,
              certificateImage: item.certificatePath,
              createBy: this.adminId,
              levelName: item.categoryName,
              displayName: this.editCerTypeForm.topDisplayName,
              displayText: item.displayText,
              parentId: this.editCerTypeRow.categoryId,
            }))
          let promiseArr = () => {
            let arr = []
            if (addParams.length > 0) {
              arr.push(request({
                url: api.baseUrl + "/certificate/fzzht-certificate-extra/saveBatch",
                method: "post",
                data: addParams
              }))
            }
            if (editParms.length > 0) {
              arr.push(request({
                url: api.baseUrl + "/certificate/fzzht-certificate-extra/updateBatch",
                method: "post",
                data: editParms
              }))
            }
            return arr
          }
          Promise.all(promiseArr()).then(values => {
            loadingInstance.close();
            console.log(values)
            this.editCerTypeDialogVisible = false
            this.getCerTypeList()
          }).catch(err => {
            loadingInstance.close();
            console.log(err)
          })
        }
      })
    },
    // 编辑等级api


    // 新增来源
    addResourceHandle() {
      let params = {
        categoryCreateAdminId: this.adminId,
        categoryName: this.addResourceForm.categoryName,
	      categoryType: '20202',
        parentId: 0,
      }
      this.$refs['addResourceForm'].validate((valid) => {
        if (valid) {
           let loadingInstance = Loading.service({
            text: '正在提交...'
          });
          request({
            url: api.baseUrl + "/certificate/yijiajia-data-category/save",
            method: "post",
            data: params
          })
          .then((res) => {
            // console.log(res);
            if (res.erroyCode == 200) {
              this.addResourceDialogVisible = false
              this.getResourceList()
              this.$refs['addResourceForm'].resetFields();
            } else {
              this.$message.error(res.errorMsg || "网络错误");
            }
          })
          .catch((err) => {
            console.log(err);
          })
          .finally(() => {
            loadingInstance.close();
          });

        } 
      })
    },
    // 新增主体类型
    addSubjectTypeHandle() {
      let params = {
        categoryCreateAdminId: this.adminId,
        categoryName: this.addSubjectTypeForm.categoryName,
	      categoryType: '20201',
        parentId: 0,
      }
      this.$refs['addSubjectTypeForm'].validate((valid) => {
        if (valid) {
           let loadingInstance = Loading.service({
            text: '正在提交...'
          });
          request({
            url: api.baseUrl + "/certificate/yijiajia-data-category/save",
            method: "post",
            data: params
          })
          .then((res) => {
            // console.log(res);
            if (res.erroyCode == 200) {
              this.addSubjectTypeDialogVisible = false
              this.getSubjectTypeList()
              this.$refs['addSubjectTypeForm'].resetFields();
            } else {
              this.$message.error(res.errorMsg || "网络错误");
            }
          })
          .catch((err) => {
            console.log(err);
          })
          .finally(() => {
            loadingInstance.close();
          });

        } 
      })
    },
    // 新增类目/业务等级
    addBusinessGradeHandle() {
      let params = {
        categoryCreateAdminId: this.adminId,
        categoryName: this.addBusinessGradeForm.categoryName,
	      categoryType: '20204',
        parentId: 0,
      }
      this.$refs['addBusinessGradeForm'].validate((valid) => {
        if (valid) {
           let loadingInstance = Loading.service({
            text: '正在提交...'
          });
          request({
            url: api.baseUrl + "/certificate/yijiajia-data-category/save",
            method: "post",
            data: params
          })
          .then((res) => {
            // console.log(res);
            if (res.erroyCode == 200) {
              this.addBusinessGradeDialogVisible = false
              this.getBusinessGradeList()
              this.$refs['addBusinessGradeForm'].resetFields();
            } else {
              this.$message.error(res.errorMsg || "网络错误");
            }
          })
          .catch((err) => {
            console.log(err);
          })
          .finally(() => {
            loadingInstance.close();
          });
        } 
      })
    },
    // 新增类目/业务类型
    addBusinessTypeHandle() {
      let params = {
        categoryCreateAdminId: this.adminId,
        categoryName: this.addBusinessTypeForm.categoryName,
	      categoryType: '20205',
        parentId: 0,
      }
      this.$refs['addBusinessTypeForm'].validate((valid) => {
        if (valid) {
           let loadingInstance = Loading.service({
            text: '正在提交...'
          });
          request({
            url: api.baseUrl + "/certificate/yijiajia-data-category/save",
            method: "post",
            data: params
          })
          .then((res) => {
            // console.log(res);
            if (res.erroyCode == 200) {
              this.addBusinessTypeDialogVisible = false
              this.getBusinessTypeList()
              this.$refs['addBusinessTypeForm'].resetFields();
            } else {
              this.$message.error(res.errorMsg || "网络错误");
            }
          })
          .catch((err) => {
            console.log(err);
          })
          .finally(() => {
            loadingInstance.close();
          });
        } 
      })
    },
  },
};
</script>

<style scoped lang="scss">
.page-wrapper {
  background: #fff;
  padding: 16px;
  margin: 10px;
  .table-head  {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 8px;
  }
  .c-remove {
    margin-right: 4px;
    cursor: pointer;
    font-size: 24px;
    &.disabled {
        color: #ccc;
        cursor: no-drop;
    }
  }
  .c-add {
    font-size: 24px;
    cursor: pointer;
  }
  .cell-box {
    margin: 0;
    .cell-item {
      height: 88px;
      border-bottom: 1px solid #eee;
      display: flex;
      justify-content: center;
      align-items: center;
      &:last-child {
        border-bottom: none;
      }
    }
    .cer-tem-pic {
      width: 80px;
      height: 80px;
      object-fit: contain;
      background: #ccc;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/certificate/config.vue